<template>
    <v-dialog
        v-model="$store.state.dispatch.finalizeCurrentOrderInProgress"
        hide-overlay
        persistent
        max-width="1200px"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Forced Completion</v-toolbar-title
                >
                <v-spacer />
                <v-btn
                    icon
                    left
                    @click="
                        $store.state.dispatch.finalizeCurrentOrderInProgress = false
                    "
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>
            <template>
                <v-stepper v-model="e6" vertical>
                    <v-stepper-step :complete="e6 > 1" step="1">
                        Select the order
                        <small>Select the order(s) to be finalized</small>
                    </v-stepper-step>

                    <v-stepper-content step="1">
                        <v-card color="#fff">
                            <v-simple-table
                                dense
                                style="border: 1px #e1e1e1 solid;"
                            >
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th class="text-left">
                                                Current Status
                                            </th>
                                            <th class="text-left">
                                                Load Num
                                            </th>
                                            <th class="text-left">
                                                Order ID
                                            </th>
                                            <th class="text-left">
                                                Terminal
                                            </th>
                                            <th class="text-left">
                                                Station
                                            </th>
                                            <th class="text-left">
                                                Station City
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="ord in OrdersToBeEvaluated"
                                            :key="ord.OrderID"
                                        >
                                            <td
                                                v-if="ord.ActiveOrder == 1"
                                                style="border-left: 8px solid #FFD500;"
                                            >
                                                <v-checkbox
                                                    v-model="
                                                        selectedOrders[
                                                            ord.OrderID
                                                        ]
                                                    "
                                                    style="margin: 0;padding: 0;height: 25px;"
                                                ></v-checkbox>
                                            </td>
                                            <td v-else></td>
                                            <td
                                                v-if="
                                                    ord.LoadStatus ==
                                                        'DISPATCHED' ||
                                                        ord.LoadStatus ==
                                                            'PRLDISPAT' ||
                                                        ord.LoadStatus ==
                                                            'PRELOAD'
                                                "
                                            >
                                                <v-icon color="gray darken-2">
                                                    mdi-dots-horizontal-circle-outline
                                                </v-icon>
                                            </td>
                                            <td
                                                v-else-if="
                                                    ord.LoadStatus ==
                                                        'INPROGRESS'
                                                "
                                            >
                                                <v-icon color="blue darken-2">
                                                    mdi-truck-fast
                                                </v-icon>
                                            </td>
                                            <td
                                                v-else-if="
                                                    ord.LoadStatus ==
                                                        'FORCEDCOMPLETION'
                                                "
                                            >
                                                <v-icon color="green darken-2">
                                                    mdi-check-circle-outline
                                                </v-icon>
                                            </td>
                                            <td
                                                v-else-if="
                                                    ord.LoadStatus == 'DONE'
                                                "
                                            >
                                                <v-icon color="green darken-2">
                                                    mdi-check-circle-outline
                                                </v-icon>
                                            </td>
                                            <td>
                                                {{
                                                    ord.LoadStatus ==
                                                        'DISPATCHED' ||
                                                    ord.LoadStatus ==
                                                        'PRLDISPAT' ||
                                                    ord.LoadStatus == 'PRELOAD'
                                                        ? 'NOTSTARTED'
                                                        : ord.LoadStatus
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    ord.LoadNumOrd == null
                                                        ? ord.LoadNum
                                                        : ord.LoadNum +
                                                          '.' +
                                                          ord.LoadNumOrd
                                                }}
                                            </td>
                                            <td>{{ ord.OrderID }}</td>
                                            <td>{{ ord.TerminalName }}</td>
                                            <td>{{ ord.StationName }}</td>
                                            <td>{{ ord.StationCity }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                        <div style="padding: 20px 0;">
                            <v-btn color="primary" @click="validateOrders">
                                Continue
                            </v-btn>
                            <v-btn
                                text
                                @click="
                                    $store.state.dispatch.finalizeCurrentOrderInProgress = false
                                "
                            >
                                Cancel
                            </v-btn>
                        </div>
                    </v-stepper-content>

                    <v-stepper-step :complete="e6 > 2" step="2">
                        Specifies the reason for change
                    </v-stepper-step>

                    <v-stepper-content step="2">
                        <div style="padding: 0 10px 0;">
                            <div
                                style="display: grid;grid-template-columns: repeat(3, 1fr);"
                            >
                                <div
                                    color="#fff"
                                    v-for="e in eventualities"
                                    :key="e.model"
                                >
                                    <v-tooltip top>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <div
                                                style="display: flex;align-items: center;"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-checkbox
                                                    style="margin: 0;padding: 0;"
                                                    v-model="models[e.model]"
                                                    :label="e.label"
                                                    color="primary"
                                                    hide-details
                                                    dense
                                                    @change="
                                                        verifyOther(e.model)
                                                    "
                                                ></v-checkbox>
                                            </div>
                                        </template>
                                        <span>{{ e.description }}</span>
                                    </v-tooltip>
                                </div>
                            </div>
                            <div v-if="IsOther" style="margin-top: 30px;">
                                <v-textarea
                                    @input="retrieveTextBody($event)"
                                    outlined
                                    no-resize
                                    hide-details
                                    dense
                                    label="Write here another reason"
                                ></v-textarea>
                            </div>
                        </div>
                        <div style="padding: 20px 0;">
                            <v-btn
                                color="primary"
                                @click="validateIfThereIsReason"
                            >
                                Continue
                            </v-btn>
                            <v-btn
                                text
                                @click="
                                    $store.state.dispatch.finalizeCurrentOrderInProgress = false
                                "
                            >
                                Cancel
                            </v-btn>
                        </div>
                    </v-stepper-content>

                    <v-stepper-step :complete="e6 > 3" step="3">
                        Review the information and finalize
                    </v-stepper-step>

                    <v-stepper-content step="3">
                        <div>
                            <v-alert
                                shaped
                                dense
                                outlined
                                type="info"
                                style="text-align: center;"
                            >
                                You are going to finalize the following orders
                                In Progress for this reason. Now the Load Status
                                will change to "Forced Completion".
                            </v-alert>
                            <div
                                style="display: grid;grid-template-columns: repeat(2, 1fr);gap: 30px;"
                            >
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Order ID
                                                </th>
                                                <th class="text-left">
                                                    Load Num
                                                </th>
                                                <th class="text-left">
                                                    Terminal
                                                </th>
                                                <th class="text-left">
                                                    Station
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="ord in ordersToBeFinalized"
                                                :key="ord.OrderID"
                                            >
                                                <td>{{ ord.OrderID }}</td>
                                                <td>
                                                    {{
                                                        ord.LoadNumOrd == null
                                                            ? ord.LoadNum
                                                            : ord.LoadNum +
                                                              '.' +
                                                              ord.LoadNumOrd
                                                    }}
                                                </td>
                                                <td>{{ ord.TerminalName }}</td>
                                                <td>{{ ord.StationName }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <div>
                                    <v-chip
                                        v-for="rs in groupedReasons"
                                        :key="rs"
                                        outlined
                                        color="primary"
                                        class="ma-2"
                                    >
                                        <strong>{{ rs }}</strong>
                                    </v-chip>
                                </div>
                            </div>
                        </div>
                        <div style="padding: 20px 0;">
                            <v-btn
                                color="primary"
                                @click="forceOrderCompletion"
                            >
                                Finalize
                            </v-btn>
                            <v-btn
                                text
                                @click="
                                    $store.state.dispatch.finalizeCurrentOrderInProgress = false
                                "
                            >
                                Cancel
                            </v-btn>
                        </div>
                    </v-stepper-content>
                </v-stepper>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
    props: ['OrdersToBeEvaluated', 'ShiftForcedCompletion'],
    components: {},
    data: function() {
        return {
            e6: 1,
            selectedOrders: {},
            eventualities: [
                {
                    model: 'opt1',
                    label: 'No Allocation',
                    description: 'No product for Badge account'
                },
                {
                    model: 'opt2',
                    label: 'Outage',
                    description: 'No product in terminal'
                },
                {
                    model: 'opt3',
                    label: 'No HOS',
                    description: 'No Hours Of Service for the driver'
                },
                {
                    model: 'opt4',
                    label: 'Weather Related',
                    description:
                        'Storm, fog or lightning may close the terminal'
                },
                {
                    model: 'opt5',
                    label: 'Benched',
                    description:
                        'Maybe he made a mistake in the terminal and was banned'
                },
                {
                    model: 'opt6',
                    label: 'Trucks Or Trailers Issues',
                    description: 'Breakdowns, skidding, air leaks, etc.'
                },
                {
                    model: 'opt7',
                    label: 'Long Lines',
                    description:
                        'Brokers mostly see long lines and prefer not to place the order'
                },
                {
                    model: 'opt8',
                    label: 'Customer Cancellation',
                    description: 'Last minute customer cancellation call'
                },
                {
                    model: 'other',
                    label: 'Other',
                    description: 'You can add another reason here'
                }
            ],
            IsOther: false,
            models: {},
            textBody: '',
            ordersToBeFinalized: [],
            groupedReasons: [],
            ordersIDs: []
        };
    },
    mounted() {},
    methods: {
        forceOrderCompletion: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            //console.log(this.ordersIDs, this.groupedReasons);
            let params = {
                orders: this.ordersIDs,
                reasons: this.groupedReasons,
                hasOther: this.IsOther
            };
            console.log(params);
            axios
                .put('order/forced-completion', params)
                .then(response => {
                    this.$store.state.isLoading = false;
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text:
                            'The order was successfully changed to "Forced Completion".'
                    });
                    this.$emit('close');
                    this.$store.state.dispatch.finalizeCurrentOrderInProgress = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                    this.$store.state.dispatch.finalizeCurrentOrderInProgress = false;
                });
        },
        groupReasons: function() {
            console.log(this.models);
            if (this.IsOther) {
                this.groupedReasons.push(this.textBody);
            }

            for (let rs of this.eventualities) {
                if (rs.model == 'other') {
                    continue;
                }
                let idx = Object.keys(this.models).indexOf(rs.model);
                console.log(idx);
                if (idx != -1) {
                    this.groupedReasons.push(rs.label);
                }
            }
            console.log(this.groupedReasons);
        },
        groupOrdersToBeFinalized: function() {
            for (let ord of this.OrdersToBeEvaluated) {
                let idx = Object.keys(this.selectedOrders).indexOf(
                    String(ord.OrderID)
                );
                console.log(idx);
                if (idx != -1) {
                    let {
                        OrderID,
                        LoadNum,
                        LoadNumOrd,
                        LoadStatus,
                        TerminalName,
                        StationName
                    } = ord;
                    this.ordersToBeFinalized.push({
                        OrderID,
                        LoadNum,
                        LoadNumOrd,
                        LoadStatus,
                        TerminalName,
                        StationName
                    });
                    this.ordersIDs.push(ord.OrderID);
                }
            }
            console.log(this.ordersToBeFinalized);
        },
        retrieveTextBody: function(evt) {
            this.textBody = evt;
            console.log(this.textBody);
        },
        verifyOther: function(emodel) {
            if (emodel == 'other' && this.IsOther) {
                this.IsOther = false;
                console.log(emodel, this.IsOther);
            } else if (emodel == 'other' && !this.IsOther) {
                this.IsOther = true;
            }
            console.log(this.models);
        },
        validateIfThereIsReason: function() {
            if (!Object.keys(this.models).length) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select at least one reason.'
                });
                return;
            }

            // Verifies that in case of "other" there is a message body
            let idx = Object.keys(this.models).indexOf('other');
            if (idx != -1 && this.models.other && this.textBody.length < 20) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text:
                        'The reason "other" must be at least 20 characters long.'
                });
                return;
            }

            let counter = 0;
            for (let r in this.models) {
                counter++;
                if (this.models[r]) {
                    this.e6 = 3;
                } else if (counter == Object.keys(this.models).length) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'You have to select at least one reason.'
                    });
                    return;
                }
            }

            this.groupReasons();
        },
        validateOrders: function() {
            // Valida que el usuario haya seleccionado al menos una orden
            if (!Object.keys(this.selectedOrders).length) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select at least one order.'
                });
                return;
            }

            let counter = 0;

            for (let ord in this.selectedOrders) {
                counter++;
                console.log(this.selectedOrders[ord]);
                console.log(this.selectedOrders);
                if (this.selectedOrders[ord]) {
                    this.e6 = 2;
                } else if (counter == Object.keys(this.selectedOrders).length) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'You have to select at least one order.'
                    });
                    return;
                }
            }

            this.groupOrdersToBeFinalized();
        }
    }
};
</script>

<style>
/* Styles here */
</style>
